import { createContext } from 'react';
import { CustomersContextType } from 'types/CustomersContextType';

export const CustomersContext = createContext<CustomersContextType|null>(null);
